type TimeSeriesPoint<X, Y> = { x: X; y: Y };
type TimeSeries<X, Y> = { id: string; data: TimeSeriesPoint<X, Y>[] };

export const convertToTimeSeries = <T, X = number, Y = number>(
  data: T[],
  options: {
    seriesKeys: readonly string[];
    xAccessor: (item: T) => X;
    yAccessor: (item: T, key: string) => Y;
    idAccessor?: (key: string) => string;
  }
): TimeSeries<X, Y>[] => {
  const { seriesKeys, xAccessor, yAccessor, idAccessor } = options;

  return seriesKeys.map((key) => {
    const points = data
      .slice()
      .sort((a, b) => {
        const ax = xAccessor(a);
        const bx = xAccessor(b);
        return ax > bx ? 1 : ax < bx ? -1 : 0;
      })
      .map((item) => ({
        x: xAccessor(item),
        y: yAccessor(item, key),
      }));

    return { id: idAccessor ? idAccessor(key) : key, data: points };
  });
};
